<script setup>
import { useRouter } from 'vue-router';
import { useStore } from 'dashboard/composables/store';
import WahaConnection from '../components/WahaConnection.vue';

const router = useRouter();
const store = useStore();
const onConnected = async data => {
  await store.dispatch('inboxes/get');
  router.replace({
    name: 'settings_inboxes_add_agents',
    params: { page: 'new', inbox_id: data.inbox_id },
  });
};
</script>

<template>
  <WahaConnection @connected="onConnected" />
</template>
